module.exports = __webpack_public_path__ + "static/media/V-img1.24445d1a.png";